import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class SoldeService {

  private apiUrl = environment.backWallet;
  constructor(private http: HttpClient, private authService: AuthService) {}
  //constructor(private http: HttpClient) {}

  getBalance(idTicket: number, account: string): Observable <any > {
    const token = this.authService.getToken();
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.get(`${this.apiUrl}/tokens/balanceOf/${idTicket}/${account}`, { headers });
  }

 // solde.service.ts
getBalanceB2C(idTicket: string, account: string): Observable<any> {
  const token = this.authService.getToken();
  const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
  return this.http.get(`${this.apiUrl}/tokens/b2c/balanceOf/${idTicket}/${account}`, { headers });
}

getMerchantTransactions(account: string): Observable<any[]> {
  const token = this.authService.getToken();
  const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
  return this.http.get<any[]>(`${this.apiUrl}/tokens/merchant-transactions/${account}`, { headers });
}

getVoucherBalance(tokenId: string, account: string): Observable<any> {
  const token = this.authService.getToken();
  const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
  return this.http.get(`${this.apiUrl}/tokens/voucher/balanceOf/${tokenId}/${account}`, { headers });
}
}
